<template>
  <div class="header py-5">
    <div class="header-content w-100 shadow">
      <div class="overlay"></div>
    
      <b-container>
        <b-row class="content d-flex align-items-center">
          <b-col class="pt-5" cols="12" md="7">
            <b-img 
              src="@/assets/logos/logo.svg" 
              alt="KILX: Stratégies d'affaires numériques" 
              class="logo my-3" 
            />

            <h1 class="slogan bold display-5 text-white">
              Le monde est numérique <span class="blinking-cursor blue">_</span>
            </h1>

            <h2 class="display-5 text-blue bold">
              Stratégies, expertise et savoir-faire<br>pour une transformation numérique réussie.
            </h2>
          </b-col>

          <b-col class="d-flex align-self-stretch flex-column pt-5" cols="12" md="5" @mouseover="endSliderInterval" @mouseleave="startSliderInterval"> 
            <img
              :key="'slide-img-' + slides[slideCurrent]"
              style="height:30vh;min-height:150px;"
              :src="slides[slideCurrent].img"
              class="slider-image active"
              :alt="'KLIX: ' + slides[slideCurrent].title"
            />

            <p class="text-silver mt-4">
              Des solutions innovantes et efficaces en matière de {{ activeSlideText.toLowerCase() }}.
            </p>

            <b-button
              :key="'slide-cta-' + slides[slideCurrent]"
              v-if="slides[slideCurrent].cta.link"
              class="mt-2 p-3 btn-cta"
              :to="slides[slideCurrent].cta.link"
            >
              {{ slides[slideCurrent].cta.text }}
            </b-button>  

            <b-button
              :key="'slide-cta-' + slides[slideCurrent]"
              v-if="slides[slideCurrent].cta.action"
              class="mt-2 p-3 btn-cta"
              @click.prevent="runMethod(slides[slideCurrent].cta.action)"
            >
              {{ slides[slideCurrent].cta.text }}
            </b-button>          
          </b-col>
        </b-row>
      </b-container>

      <div class="d-flex flex-column slides-controler mt-3 pb-5">
        <div class="d-flex justify-content-center">
          <a
            v-for="(slide, index) in slides"
            :key="'slide-controler-' + index"
            class="mx-1 text-blue slide-controler"
            :class="isThisSlideActive(index)"
            href="#"
            @click.prevent="setCurrentSlide(index)"
          >
            <font-awesome-icon icon="window-minimize" size="2x" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: [],
  data() {
    return {
      slideCurrent: 0,
      slides: [
        {
          title: `Numérisation de documents`,
          img: require(`@/assets/svg/stack.svg`),
          cta: {
            text: `Demandez un devis pour la numérisation de vos archives`,
            action: `sendMessage`
          }
        },
        {
          title: `Gestion des documents électroniques`,
          img: require(`@/assets/svg/eDocuments.svg`),
          cta: {
            text: `Demandez une démonstration gratuite`,
            action: `sendMessage`
          }
        },
        {
          title: `Automatisation des processus d'affaires`,
          img: require(`@/assets/svg/automation.svg`),
          cta: {
            text: `Consulter notre blog pour en apprendre plus`,
            link: { name: `blog` }
          }
        }
      ],
      sliderInterval: null
    }
  },
  computed: {
    activeSlideText() {
      return this.slides[this.slideCurrent].title
    }
  },
  mounted() {
    let header = document.getElementsByClassName('header')[0]    
    let navbar = document.getElementById('navbar')
    let paddingTop = 0;

    if( navbar !== null ) {
      paddingTop =  navbar.offsetHeight
    }

    if(header) header.style.margin = paddingTop + 'px 0 0 0'
  },
  created() {
    this.startSliderInterval()
  },
  destroyed() {
    this.endSliderInterval()
  },
  methods: {
    runMethod(method) {
      this[method]()
    },
    sendMessage(subject) {
      this.$emit('sendMessage', subject)
    },
    next: function() {
      this.currentNumber += 1
      return false
    },
    prev: function() {
      this.currentNumber -= 1
      return false
    },
    isThisSlideActive(slide) {
      if(this.slideCurrent === slide) return "active"     
      return ''
    },
    setCurrentSlide(slide) {
      clearInterval(this.sliderInterval);
      this.slideCurrent = slide
      this.startSliderInterval()

      return false
    },
    startSliderInterval() {
      this.sliderInterval = setInterval(() => {
          if(this.slideCurrent < this.slides.length - 1) this.slideCurrent += 1
          else this.slideCurrent = 0
      }, 4000);

      return false
    },
    endSliderInterval() {
      clearInterval(this.sliderInterval);
      return false
    }
  }
}
</script>

<style scoped>
.header-content,
.content,
.slides-controler {
  position: relative;
  z-index: 10;
}

.header-content {
  position: relative;
  background: url("../assets/images/code.jpg") no-repeat center fixed;
  background-size: cover;
}

.slide {
  width: 100%;
  height: 0;
}

.slide.active {
  height: 100%;
}

.overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0,0,0,0.9);
}

.header-ambiance {
  max-height: 50vh;
}

.slide-controler.active {
  color: #fff !important;
}
.slider-image {
  right: 0;
  opacity: 0.1;
  transition: all 1s ease-in-out;
}

.slider-image.active {
  opacity: 1;
}
</style>
